import { Link } from 'react-router-dom';

export default function ServiceSection() {
  const services = [
    {
      icon: "ri-presentation-line",
      title: "企業研修・セミナー",
      description: "おもてなしとマナーを学ぶ実践的な企業研修。VIP対応からビジネスエチケットまで、一流のサービスマインドを育成いたします。",
      link: "/services/corporate-training"
    },
    {
      icon: "ri-user-star-line",
      title: "プライベート執事サービス", 
      description: "特別な日を完璧に演出。パーソナルな執事サービスで、忘れられない体験をお約束いたします。細部まで心を配った上質なおもてなし。",
      link: "/services/private-butler"
    },
    {
      icon: "ri-graduation-cap-line",
      title: "マナー講座",
      description: "社交の場で自信を持てる、実践的なマナー講座。個人からグループまで対応し、品格ある振る舞いを身につけていただきます。",
      link: "/services/manner-course"
    },
    {
      icon: "ri-lightbulb-line", 
      title: "コンサルティング",
      description: "ホスピタリティ向上のための専門的なアドバイス。サービス業の質を高め、お客様満足度の向上をサポートいたします。",
      link: "/services/consulting"
    }
  ];

  return (
    <section id="services" className="py-32 bg-gray-900 relative overflow-hidden">
      {/* Elegant background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-20 w-40 h-40 border border-amber-400 rounded-full"></div>
        <div className="absolute bottom-1/4 right-20 w-32 h-32 border border-amber-400 rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 border border-amber-400 rounded-full"></div>
      </div>

      <div className="max-w-6xl mx-auto px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center mb-8">
            <div className="w-20 h-px bg-amber-400"></div>
            <span 
              className="mx-8 text-amber-400 text-sm tracking-[0.3em] font-light uppercase"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              Our Services
            </span>
            <div className="w-20 h-px bg-amber-400"></div>
          </div>
          
          <h2 
            className="text-5xl md:text-6xl font-light text-white mb-8 tracking-wide"
            style={{ 
              fontFamily: '"Noto Serif JP", serif',
              letterSpacing: '0.02em'
            }}
          >
            あなたのニーズに合わせた<br />上質なサービス
          </h2>
          
          <p 
            className="text-xl text-gray-300 font-light max-w-6xl mx-auto leading-relaxed"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              lineHeight: '1.8'
            }}
          >
            一流のおもてなしを通じて、特別な価値をお届けいたします
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-10 mb-16">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="btn-gold group relative bg-gray-800/50 hover:bg-gray-800 backdrop-blur-sm border border-amber-400/20 hover:border-amber-400/60 p-10 transition-all duration-500 block"
            >
              {/* Icon Container */}
              <div className="mb-8">
                <div className="relative inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-amber-400/20 to-amber-500/20 border border-amber-400/40 rounded-full group-hover:scale-110 group-hover:border-amber-400 transition-all duration-500">
                  {/* Icon glow effect */}
                  <div className="absolute inset-0 bg-amber-400/20 rounded-full blur-lg opacity-0 group-hover:opacity-60 transition-opacity duration-500"></div>
                  
                  <i className={`${service.icon} text-3xl text-amber-400 relative z-10 group-hover:text-amber-300 transition-colors duration-300`}></i>
                </div>
              </div>

              {/* Content */}
              <div>
                <h3 
                  className="text-2xl font-light text-white mb-6 group-hover:text-amber-300 transition-colors duration-300"
                  style={{ 
                    fontFamily: '"Noto Serif JP", serif',
                    letterSpacing: '0.02em'
                  }}
                >
                  {service.title}
                </h3>
                
                <p 
                  className="text-gray-300 leading-relaxed font-light"
                  style={{ 
                    fontFamily: '"Noto Sans JP", sans-serif',
                    lineHeight: '1.8'
                  }}
                >
                  {service.description}
                </p>
              </div>

              {/* Hover accent lines */}
              <div className="absolute top-0 left-0 w-0 h-1 bg-gradient-to-r from-amber-400 to-amber-500 group-hover:w-full transition-all duration-500"></div>
              <div className="absolute bottom-0 right-0 w-0 h-1 bg-gradient-to-l from-amber-400 to-amber-500 group-hover:w-full transition-all duration-500 delay-100"></div>
              
              {/* Corner decorations */}
              <div className="absolute top-4 right-4 w-8 h-8 border-r border-t border-amber-400/20 group-hover:border-amber-400/80 transition-colors duration-500"></div>
              <div className="absolute bottom-4 left-4 w-8 h-8 border-l border-b border-amber-400/20 group-hover:border-amber-400/80 transition-colors duration-500"></div>
              
              {/* Subtle background pattern */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500">
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 border border-amber-400 rounded-full"></div>
              </div>
            </Link>
          ))}
        </div>

        {/* Service Details Button */}
        <div className="text-center">
          <Link
            to="/services"
            className="btn-gold group relative inline-flex items-center bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-black px-12 py-4 font-light text-lg transition-all duration-500 overflow-hidden whitespace-nowrap"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              letterSpacing: '0.1em'
            }}
          >
            <span className="relative z-10 mr-3">Service Details</span>
            <i className="ri-arrow-right-line relative z-10 text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
            
            {/* Hover effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-amber-500 to-amber-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            
            {/* Decorative shine effect */}
            <div className="absolute inset-0 bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
          </Link>
        </div>
      </div>

      {/* Section divider */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-40 h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent"></div>
    </section>
  );
}
